import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
  const { authenticated, checkingSession } = useAuth();
  const location = useLocation();

  if (checkingSession) return null; // or a spinner, if you have one
  if (!authenticated) return <Navigate to="/login" state={{ from: location }} replace />;

  return <Outlet />;
}